import React from 'react'

function Plane({ colorCode, planeClass }) {
    return (
        <svg className={`MuiSvgIcon-root ${planeClass}`} viewBox="0 0 30 31">
            <path fillRule="evenodd" clipRule="evenodd" d="M24.7743 18.1433L22.7118 18.1431L15.6735 27.2185C15.5786 27.3801 15.3862 27.4647 15.1963 27.4442L12.8209 27.1054C12.5464 27.0771 12.3386 26.7462 12.4386 26.4871L14.8673 18.1426L9.37256 18.1422L7.87721 20.7612C7.79514 20.9099 7.64379 20.9946 7.46422 21.0048L5.42742 21.0047C5.13755 21.0072 4.91178 20.725 4.95281 20.4429L6.62245 15.7512L4.95213 11.09C4.88285 10.8001 5.13679 10.5616 5.41897 10.541L7.46347 10.5284C7.59686 10.5284 7.838 10.6413 7.88162 10.7721L9.37479 13.3939L14.867 13.3917L12.4397 5.04423C12.3498 4.73896 12.573 4.41832 12.8937 4.42091L15.6103 4.41854C15.7667 4.43138 15.9386 4.51604 16.013 4.65201L22.7372 13.3923L24.774 13.3924C30.5458 13.3929 30.541 18.1437 24.7743 18.1433Z" fill={colorCode} />
        </svg>
    )
}

export default Plane
